import { MenuService } from '../../services/menu.service';
import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from '@app/modules/authentication/services/authentication.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
import { MenuOption } from '@app/core/models/menu-option.model';
import { LoggerService } from '@app/core/services/logger.service';
import { ResponseStatus } from '@app/core/enums/response-status.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { GenericDialogComponent } from '@app/shared/components/generic-dialog/generic-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AppProfile } from '@app/core/enums/app-profile.enum';
import { AppPermission } from '@app/core/enums/app-permission.enum';
const logger = new LoggerService('HeaderBarComponent');

@Component({
  selector: 'dhl-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  animations: [
    trigger('hamburguerX', [
      state('hamburguer', style({})),
      state(
        'topX',
        style({
          transform: 'rotate(45deg)',
          transformOrigin: 'left'
        })
      ),
      state(
        'hide',
        style({
          opacity: 0
        })
      ),
      state(
        'bottomX',
        style({
          transform: 'rotate(-45deg)',
          transformOrigin: 'left'
        })
      ),
      transition('* => *', [animate('0.3s')])
    ])
  ]
})
export class HeaderBarComponent implements OnInit {
  @ViewChild('menu', { static: false }) menu!: ElementRef<HTMLInputElement>;
  @ViewChild('navigationSidenav', { static: false }) navigationSidenav!: MatSidenav;
  enumAppPermission = AppPermission;

  isHamburguer = true;
  isEnableOption: boolean = false;
  menuOptions: MenuOption[] = [];

  opcionesmenu = [
    { nombre: 'option1', seleccionada: false },
    { nombre: 'option2', seleccionada: false },
    { nombre: 'option3', seleccionada: false },
    { nombre: 'option4', seleccionada: false },
    { nombre: 'option5', seleccionada: false }
  ];

  isVisibleLogoutModal: boolean = false;
  isLogued: boolean = false;
  isEnableMenu: boolean = true;
  isDifferentOfLoginPage: boolean = false;
  quitMenuInvisible: boolean = false;
  numberOfProducts: number = 0;

  isShowing: boolean = false;

  selectedStore: string = '';

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly authService: AuthenticationService,
    private readonly storage: SaveObjectInLocalServiceService,
    public dialog: MatDialog,
    private readonly menuService: MenuService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    this.numberOfProducts = this.storage.getObject('itemsCart') ? this.storage.getObject('itemsCart') : 0;
  }

  protected session = {
    userName: '',
    fullName: '',
    authentication: false,
    fullNameResponsive: ''
  };

  ngOnInit(): void {
    logger.warn('Validacion deploy 2.9.9.9.9.7.5 QA 10.30');

    // Generamos la primer validación de la pagina al entrar al componente
    this.validatePage();

    // Validamos por segunda vez si se realiza un cambio de ruta dentro de la página
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.validatePage();

        // this.validateSessionLogued();
      }
    });

    // Valida si se da click en funciones de regrear o avanzar del navegador
    this.location.subscribe((event) => {
      logger.info(event);
      logger.info('Se dio click en regresar del navegador');
      this.validateSessionLogued();
      this.validatePage();
    });

    this.menuService.menuData.subscribe((data: MenuOption[]) => {
      this.menuOptions = data;
      this.cdRef.detectChanges();
    });
  }

  onToggleMenu(event: any): void {
    logger.info(event);
    this.isHamburguer = !this.isHamburguer;
  }

  deseleccionarMenusChecks(indice: number) {
    if (this.opcionesmenu[indice].seleccionada) {
      this.hiddenMenusToggle(indice, false);
    }
  }

  // Oculta los toggle menu o menus desplegables
  hiddenMenusToggle(indice: number, hiddenAll: boolean) {
    if (!hiddenAll) {
      this.opcionesmenu.forEach((opcion, index) => {
        if (indice !== index) {
          opcion.seleccionada = false;
        }
      });
    } else {
      this.opcionesmenu.forEach((opcion) => {
        opcion.seleccionada = false;
      });
    }
  }

  navigateToHome() {
    if (this.router.url !== '/authentication/login') {
      void this.router.navigate(['./home/homepage']);
    }
  }

  // Valida si la pagina o componente que se muestra
  validatePage() {
    const url = this.getUrlPathNavigation();
    const urlArray = url.split('/');
    const uri = urlArray.pop();
    logger.info(uri);

    // SI la pagina o componente es login, dehabilitamos el menú principal
    if (uri === 'login') {
      logger.info('Estamos en login, procediendo a deshabilitar menu principal...');
      this.isEnableMenu = false;
      this.isDifferentOfLoginPage = false;
    } else if (uri === 'homepage') {
      if (this.storage.getObject('session') !== null && this.storage.getObject('session') !== undefined) {
        logger.info('Estamos en otra pagina y si hay session ');
        logger.info('Agregamos');
        this.isEnableOption = true;
        this.isEnableMenu = true;
        this.isDifferentOfLoginPage = true;
        const cookie = this.authService.getCookie('.AspNetCore.Cookies');
        logger.info('Esta es la cookie obtenida');
        logger.info(cookie);
        const valuessession = this.storage.getObject('session').split('|');
        logger.info(valuessession);
        logger.info(sessionStorage.getItem('session')!);

        this.session = {
          userName: valuessession[2],
          fullName: this.decodeString(valuessession[1].split(' ')[0]),
          authentication: valuessession[0],
          fullNameResponsive: this.decodeString(valuessession[1])
        };
      } else {
        this.isEnableMenu = true;
        logger.info('Quitamoss');
        this.quitMenuInvisible = true;
        this.isDifferentOfLoginPage = true;
      }
      this.validateSessionLogued();
    } else {
      this.validateSessionStorage();
      this.validateSessionLogued();
    }
  }

  valdiateLocationAndEmitMenu() {
    if (this.getUrlPathNavigation().split('/').pop() !== 'login') {
      this.loadMenu();
    }
  }

  setNumberProductsFromCart(numberProducts: number) {
    this.numberOfProducts = numberProducts;
  }

  validateSessionStorage() {
    if (this.storage.getObject('session')) {
      logger.info('Estamos en otra pagina y si hay session');
      logger.info('Agregamos');

      this.isEnableOption = true;
      this.isEnableMenu = true;
      this.isDifferentOfLoginPage = true;
      this.quitMenuInvisible = false;

      const cookie = this.authService.getCookie('.AspNetCore.Cookies');
      logger.info('Esta es la cookie obtenida', cookie);

      const valuessession = this.storage.getObject('session').split('|');
      logger.info(valuessession);
      logger.info(sessionStorage.getItem('session')!);

      this.session = {
        userName: valuessession[2],
        fullName: this.decodeString(valuessession[1].split(' ')[0]),
        authentication: valuessession[0],
        fullNameResponsive: this.decodeString(valuessession[1])
      };
    } else {
      logger.info('Quitamos');
      this.isEnableMenu = false;
      this.isDifferentOfLoginPage = true;
    }
  }

  // Decodificacion de texto para el User del header
  decodeString(str: string): string {
    const replacements: { [key: string]: string } = {
      '&#193;': 'Á',
      '&#225;': 'á',
      '&#201;': 'É',
      '&#233;': 'é',
      '&#205;': 'Í',
      '&#237;': 'í',
      '&#211;': 'Ó',
      '&#243;': 'ó',
      '&#218;': 'Ú',
      '&#250;': 'ú',
      '&#220;': 'Ü',
      '&#252;': 'ü',
      '&#209;': 'Ñ',
      '&#241;': 'ñ'
      // Añadir aquí otros caracteres a reemplazar
    };
    let decoded = str;
    for (const [encoded, decodedChar] of Object.entries(replacements)) {
      decoded = decoded.replace(new RegExp(encoded, 'g'), decodedChar);
    }
    return decoded;
  }

  getUrlPathNavigation(): string {
    const url: string = window.location.pathname;
    return url;
  }

  // showModalLogout() {
  //   this.isVisibleLogoutModal = true;

  // }

  showModalLogout(): void {
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      data: {
        title: '¿Quiere cerrar sesión?',
        message: 'Al cerrar sesión, cualquier elemento no guardado o compra sin completar será cancelada.',
        showAccept: true,
        showCancel: true,
        cancelLabel: 'Cancelar',
        acceptLabel: 'Cerrar sesión'
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        void this.navigationSidenav.toggle();
        this.logoutSession();
        this.storage.removeObject('session');
        this.storage.removeObject('permissions');
        this.storage.removeObject('profile');
        this.storage.removeObject('email');
        this.storage.removeObject('store');
      }
    });
  }

  validateSessionLogued() {
    this.authService.validateAccountIsLogued().subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          if (response.data.islogued) {
            this.isLogued = true;
            this.selectedStore = this.storage.getObject('store') ?? '';
            this.valdiateLocationAndEmitMenu();
          } else {
            this.isLogued = false;
            this.storage.removeObject('persistenceSession');
            this.storage.removeObject('session');
            this.storage.removeObject('store');
            this.selectedStore = '';
          }
        }
      },
      error: (e) => {
        logger.error(e);
      },
      complete: () => {
        logger.info('ValidateSessionLogued complete');
      }
    });
  }

  logoutSession() {
    this.authService.logout().subscribe({
      next: (response: HttpServerResponse<any>) => {
        if (response.status === ResponseStatus.Ok) {
          this.storage.removeObject('session');
          if (this.storage.getObject('persistenceSession')) {
            this.storage.removeObject('persistenceSession');
          }
          if (this.storage.getObject('store')) {
            this.storage.removeObject('store');
          }
          if (this.storage.getObject('validEmail')) {
            this.storage.removeObject('validEmail');
          }
          if (this.storage.getObject('detailODCId')) {
            this.storage.removeObject('detailODCId');
          }
          if (this.storage.getObject('store')) {
            this.storage.removeObject('store');
          }

          this.menuService.emitMenu([]);
          window.location.href = 'home/homepage';
        }
      },
      error: (e) => {
        logger.error(e);
      },
      complete: () => {
        logger.info('logout process complete');
      }
    });
  }

  navigateToCart() {
    if (this.isLogued) {
      const userProfile = this.authService.getProfileSession();
      if (userProfile === AppProfile.Employee) {
        void this.router.navigate(['/clients/cart/retail']);
      } else {
        void this.router.navigate(['/clients/cart']);
      }
    } else {
      void this.router.navigate(['/clients/cart']);
    }
  }

  hiddenMenu(isOptionOfToggle: boolean) {
    this.menu.nativeElement.checked = false;
    /**
     * Le pasamos como indice 0 y parametro true ya que
     * solamente requerimos que quite todos los toggle menu
     */
    if (!isOptionOfToggle) {
      this.hiddenMenusToggle(0, true);
    }
  }

  handleChildVariableChange(newChildVariableValue: boolean) {
    this.isVisibleLogoutModal = newChildVariableValue;
  }

  isChildRouteActive(submenu: MenuOption[]): boolean {
    return submenu.some((e) => e.url === this.router.routerState.snapshot.url);
  }

  isCurrentUrl(menuOption: MenuOption): boolean {
    return menuOption.url === this.router.routerState.snapshot.url;
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: unknown): void {
    void this.navigationSidenav.close();
  }

  loadMenu() {
    this.menuService.getMenu().subscribe({
      next: (response: HttpServerResponse<MenuOption[]>) => {
        if (response.status === ResponseStatus.Ok) {
          this.menuService.emitMenu(response.data as MenuOption[]);
        } else {
          this.menuService.emitMenu([]);
        }
      },
      error: (error: HttpErrorResponse) => {
        logger.error(error);
        this.menuService.emitMenu([]);
      },
      complete: () => logger.info('get menu complete')
    });
  }
}
